import { render, staticRenderFns } from "./result-waiting.vue?vue&type=template&id=73ebf362&scoped=true&"
import script from "./result-waiting.vue?vue&type=script&lang=js&"
export * from "./result-waiting.vue?vue&type=script&lang=js&"
import style0 from "./result-waiting.vue?vue&type=style&index=0&id=73ebf362&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ebf362",
  null
  
)

export default component.exports